// extracted by mini-css-extract-plugin
module.exports = {"title":"RankedKeywords_title__6GcAB","groups":"RankedKeywords_groups__OQ7wo","group":"RankedKeywords_group__OBva_"};